import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { Brand } from '../../../shared/interfaces/brand.type';

/** Fetch the list of brands the current user can work on. */
export const loadBrands = createAction('[Brand] Load Brands');

/**
 * Brands loaded. The effect also reconciles the active brand:
 * - if a brand was stored for this user and is still in the list, keep it
 * - otherwise pick the first accessible brand
 * - if the list is empty, clear the active brand
 */
export const loadBrandsSuccess = createAction(
    '[Brand] Load Brands Success',
    props<{ brands: Brand[] }>()
);

export const loadBrandsFailure = createAction(
    '[Brand] Load Brands Failure',
    props<{ error: HttpErrorResponse }>()
);

/** User picked a brand from the switcher (or the reconciler chose one). */
export const setActiveBrand = createAction(
    '[Brand] Set Active Brand',
    props<{ brandId: number | null }>()
);

/** Wipe brand state (logout, unauthorized). */
export const clearBrandState = createAction('[Brand] Clear State');
